module.exports = __webpack_public_path__ + "img/dcxzsg26.67a9da5d.png";